import SuperRepository from '../superRepository'

export default new (class OfferPartnerBaselineDepositHistoryRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_bl_deposit_history'
  }
  updateBlDepositHistory = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}`, params)
})()